import * as m from '../../localization/out/messages.js';

/**
 * Categorical ETA window keys (spec §4 `eta_window`). The FE sets one of these; SN echoes
 * it back on both `ticket_details` and `ticket_list` as `{ value, display_value }`, where
 * `value` is the key below. Shared by the detail page (chip seeding) and the overview list.
 */
export const ETA_WINDOW_KEYS: ReadonlySet<string> = new Set([
  'early_morning',
  'morning',
  'midday',
  'afternoon',
  'evening',
]);

/**
 * Localized label for a categorical ETA window value. We render our own localized ranges
 * rather than SN's `display_value` ("Morning [8-12]") so the wording matches the rest of
 * the app and follows the user's language. Unknown values fall back to the raw value.
 */
export function etaWindowLabel(value: string): string {
  switch (value) {
    case 'early_morning':
      return m.eta_window_early_morning();
    case 'morning':
      return m.eta_window_morning();
    case 'midday':
      return m.eta_window_midday();
    case 'afternoon':
      return m.eta_window_afternoon();
    case 'evening':
      return m.eta_window_evening();
    default:
      return value;
  }
}
